import { useParams } from "react-router-dom";
import ViewReviewHeader from "src/components/pages/Summary/ViewReview/ViewReviewHeader";
import Section from "src/components/shared/EntriesGenerator/Section/Section/Section";
import { useVerifyEntries } from "src/pages/Summary/Summary.hooks";
import VerificationSignature from "src/pages/Summary/VerifyEntries/VerificationSignature/VerificationSignature";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";

const ViewAuditEntry = () => {
  const { idType, lbeidOrPartId, aid } = useParams();
  const { sections, restricted, authorized, lbid, idata, ...headerProps } =
    useVerifyEntries("get-review-entry-reviews", "get-reviews-flag", {
      params: {
        yachtid: getYachtId(),
        [String(idType)]: lbeidOrPartId,
        aid,
      },
    });

  return (
    <PageContainer>
      <ViewReviewHeader {...headerProps} audit />
      {/* {restricted === true && authorized === false ? (
        <AuthLogbookModal
          opened={true}
          open={open}
          close={close}
          lbid={lbid ?? ""}
        />
      ) : null} */}

      {(!restricted && !authorized) ||
      (restricted === true && authorized === true)
        ? sections.map((s, i) => <Section key={i} sIndex={i} section={s} />)
        : null}

      {idata && <VerificationSignature idata={idata} title="Signature" />}
    </PageContainer>
  );
};

export default ViewAuditEntry;
